/**
 * Created by chocho on 11/6/19.
 */
let newsData = {
  "news": [
    {
      "date": "Nov 2026",
      "text": "🚗 Attending <a href='https://uist.acm.org/2026/' target='_blank'>UIST 2026</a> in Detroit, MI, where I'm serving as a Posters Co-chair! I'm presenting <a href='https://augmented-perception.org/publications/2026-contextXR.html' target='_blank'><i>A Benchmarking Framework for Context-aware XR Interfaces</i></a> (<a href='https://arxiv.org/abs/2609.30466' target='_blank'>preprint</a>), and my student Nancy is presenting <a href='https://augmented-perception.org/publications/2026-atmosteer.html' target='_blank'><i>AtmoSteer</i></a>, both on Tuesday (Nov 3)"
    },
    {
      "date": "Oct 2026",
      "text": "👩🏻‍🏫 Invited talk at Princeton’s Situated Interactions Lab (Ψ Lab), hosted by <a href='https://parastooabtahi.com/' target='_blank'>Parastoo Abtahi</a>"
    },
    {
      "date": "Sep 2026",
      "text": "🧑‍⚖️ Serving on the <a href='https://chi2027.acm.org/' target='_blank'>CHI 2027</a> Program Committee as an Associate Chair (AC)"
    },
    {
      "date": "Sep 2026",
      "text": "🤖 Attending <a href='https://2026.ieee-iros.org/' target='_blank'>IROS 2026</a> in Pittsburgh as a student volunteer"
    },
    {
      "date": "Jun 2026",
      "text": "🏔️ Attending <a href='https://hcic.org/' target='_blank'>HCIC 2026</a> in Colorado"
    },
    {
      "date": "Jun 2026",
      "text": "🇯🇵 Attending <a href='https://shonan.nii.ac.jp/seminars/244/' target='_blank'>Shonan Meeting on AR and AI: Everyday AR through AI-in-the-Loop</a>"
    },
    {
      "date": "May 2026",
      "text": "👓 Joined Google as a Student Researcher"
    },
    {
      "date": "May 2026",
      "text": "🎉 Successfully proposed my thesis, <i>Perceptually Intelligent User Interfaces for Spatial Computing</i>. Huge thanks to my committee members: <a href='https://www.davidlindlbauer.com/' target='_blank'>David Lindlbauer</a>, <a href='https://hcii.cmu.edu/people/ken-koedinger' target='_blank'>Ken Koedinger</a>, <a href='https://chrisharrison.net/' target='_blank'>Chris Harrison</a>, and <a href='https://me.stanford.edu/people/sean-follmer' target='_blank'>Sean Follmer</a>"
    },
    {
      "date": "May 2026",
      "text": "🏆 Selected as a recipient of <a href='https://linksim.org/' target='_blank'>Link Foundation Fellowship in Modeling, Simulation, and Training</a>!"
    },
    {
      "date": "Apr 2026",
      "text": "🇪🇸 CHI 2026: Presented <i>Simulating Human Audiovisual Search Behavior</i> in <a href='https://programs.sigchi.org/chi/2026/program/session/224971' target='_blank'>Optimizing Interactive Systems</a> session"
    },
    {
      "date": "Mar 2026",
      "text": "👩🏻‍🏫 Guest lecture in Mayank Goel \& Yuvraj Agarwal's <i>Human-AI Interaction Using Sensing Systems</i> class at Carnegie Mellon University"
    },
    {
      "date": "Feb 2026",
      "text": "👩🏻‍🏫 Invited talk at HCI Seminar@Columbia"
    },
    {
      "date": "Feb 2026",
      "text": "👩🏻‍🏫 Invited talk at NYU Immersive Computing Lab, hosted by Qi Sun"
    },
    {
      "date": "Nov 2025",
      "text": "👩🏻‍🏫 Guest lecture in David Lindlbauer's <i>Interactive Extended Reality</i> class at Carnegie Mellon University"
    },
    {
      "date": "Nov 2025",
      "text": "👩🏻‍🏫 Invited talk at Stanford HCI Lunch"
    },
    {
      "date": "Nov 2025",
      "text": "👩🏻‍🏫 Invited talk at Stanford SHAPE Lab, hosted by Sean Follmer & Yujie Tao"
    },
    {
      "date": "Nov 2025",
      "text": "👩🏻‍🏫 Invited talk at Google XR, hosted by Ruofei Du & Minsuk Chang"
    },
    {
      "date": "Nov 2025",
      "text": "👩🏻‍🏫 Poster presentation at <a href='https://www.cmu.edu/xrtc/news/2025/december/symposium2025.html' target='_blank'>XRTC Symposium</a>"
    },
    {
      "date": "Sep 2025",
      "text": "🇰🇷 UIST 2025: <a href='https://programs.sigchi.org/uist/2025/program/content/209370' target='_blank'>Perceptually Intelligent UI for Augmented Everyday Interaction</a> @ Doctoral Symposium, Registration Co-chair, Session Chair, UIST Rockstar Breakfast Panels"
    },
    {
      "date": "Jun 2025",
      "text": "🇫🇮 Visiting researcher with Prof. <a href='https://users.aalto.fi/~oulasvir/' target='_blank'>Antti Oulasvirta</a> at Computational Behavior Lab, Aalto University, Finland"
    },
    {
      "date": "May 2025",
      "text": "👩🏻‍🏫 Invited talk at Miraikan Accessibility Lab, hosted by Xiyue Wang"
    },
    {
      "date": "Apr 2025",
      "text": "🇯🇵 CHI 2025: Presenting <i>Persistent Assistant</i> in <a href='https://programs.sigchi.org/chi/2025/program/session/195002' target='_blank'>Agent Design</a> session"
    },
    // {
    //   "date": "Apr 2025",
    //   "text": "✈️ Attending CHI 2025 in Yokohama, Japan (April 26 - May 1)"
    // },
    {
      "date": "Mar 2025",
      "text": "🇫🇷 IEEE VR 2025: Presenting <i>Audiovisual XR Notifications</i>"
    },
    // {
    //   "date": "Mar 2025",
    //   "text": "✈️ Attending IEEE VR 2025 in Saint-Malo, France (March 10 - 13)"
    // },
    {
      "date": "Feb 2025",
      "text": "👩🏻‍🏫 Guest lecture in Alexandra Ion's <i>Computational Methods for Interactive Systems</i> class at Carnegie Mellon University"
    },
    {
      "date": "Jan 2025",
      "text": "👩🏻‍🏫 Invited talk at Seoul National University HCS Lab"
    },
    {
      "date": "Dec 2024",
      "text": "👩🏻‍🏫 Invited talk at KAIST"
    },
    {
      "date": "Nov 2024",
      "text": "👩🏻‍🏫 Guest lecture in Michael Nebeling's <i>Introduction to AR/VR Application Design</i> class at University of Michigan"
    },
    {
      "date": "Nov 2024",
      "text": "👩🏻‍🏫 Guest lecture in Yukang Yan's <i>Introduction to Human-Computer Interaction</i> class at University of Rochester"
    },
    {
      "date": "Oct 2024",
      "text": "🤝 Serving as Registration Co-chair for UIST 2025 in Busan, South Korea 🇰🇷"
    },
    {
      "date": "Oct 2024",
      "text": "👩🏻‍🏫 Research talk about Auptimize at CMU VASC Seminar"
    },
    // {
    //   "date": "Oct 2024",
    //   "text": "👩🏻‍🏫 Two paper presentations (Auptimize and SonoHaptics) at UIST 2024"
    // },
    {
      "date": "Oct 2024",
      "text": "🌉 UIST 2024: Presenting <i>Auptimize</i> and <i>SonoHaptics</i>"
      // Attending UIST 2024 in Pittsburgh, USA 🌉"
    },
    {
      "date": "May 2024",
      "text": "👩🏻‍💻 Research Scientist Intern at Meta Reality Labs, Redmond, USA (May - Sep)"
    },
    // {
    //   "date": "May 2024",
    //   "text": "👩🏻‍🏫 Paper presentation (MineXR) at CHI 2024"
    // },
    {
      "date": "May 2024",
      "text": "🌺 CHI 2024: Presenting MineXR" 
      // Attending CHI 2024 in Honolulu, Hawaii (May 10 - 17)"
    },
    {
      "date": "Nov 2023",
      "text": "🏆 BlendMR won the Best Paper Award at ACM ISS 2023!"
    },
    {
      "date": "Oct 2023",
      "text": "👩🏻‍🏫 Paper presentation (RealityReplay) at UbiComp 2023"
    },
    {
      "date": "Oct 2023",
      "text": "✈️ Attending UbiComp 2023 in Cancún, Mexico (Oct 8 - 13)"
    },
    {
      "date": "Sep 2023",
      "text": "✈️ 10th Heidelberg Laureate Forum, Heidelberg, Germany (Sep 23 - 30)"
    },
    {
      "date": "May 2023",
      "text": "👩🏻‍💻 Research Scientist Intern at Meta Reality Labs, Redmond, USA (May - Sep)"
    },
    {
      "date": "Oct 2022",
      "text": "✈️ UIST 2022 @ Bend, Oregon, USA (Oct 29 - Nov 4) 🎃"
    },
    {
      "date": "Sep 2022",
      "text": "👩🏻‍🏫 Paper presentation (FLAME) at UbiComp 2022"
    },
    {
      "date": "Sep 2022",
      "text": "✈️ UbiComp 2022 @ Cambridge, UK (Sep 11 - Sep 15)"
    },
    {
      "date": "Jun 2022",
      "text": "✈️ Summer School on Computational Interaction @ Saarbrücken, Germany (Jun 13 - 18)"
    },
    {
      "date": "Apr 2022",
      "text": "✈️ CHI 2022 @ New Orleans, LA (Apr 29 - May 7)"
    },
    {
      "date": "Nov 2021",
      "text": "👩🏻‍🏫 Presentation at AIChallengeIoT workshop @ ACM SenSys 2021"
    },
    {
      "date": "Oct 2021",
      "text": "🏆 CSCW 2021 Best Paper Award & Methods Recognition"
    },
    {
      "date": "Oct 2021",
      "text": "👩🏻‍🏫 Paper presentation (Finesse) at CSCW 2021"
    },
    {
      "date": "Oct 2021",
      "text": "👩🏻‍🔧 Student volunteer at UIST 2021"
    },
    {
      "date": "Aug 2021",
      "text": "📍 Moved to Pittsburgh, PA for my PhD at CMU"
    },
    {
      "date": "Aug 2021",
      "text": "🏆 Bell Labs Summer Intern Award for Outstanding Innovation"
    },
    // {
    //   "date": "Jul 2021",
    //   "text": "🗞 Paper accepted to ACM CSCW 2021"
    // },
    {
      "date": "May 2021",
      "text": "👩🏻‍💻 Starting my internship at Nokia Bell Labs, Cambridge, UK"
    },
    {
      "date": "Jan 2021",
      "text": "👩🏻‍🏫 Presentation at HCI Korea 2021 Positive Computing Workshop"
    },
    {
      "date": "Dec 2020",
      "text": "👩🏻‍🏫 SIGCHI CSCW Asia Winter School (AWS) 2020 on Dec 18-19"
    },
    {
      "date": "Nov 2020",
      "text": "🏆 NAVER Ph.D. Fellowship Award"
    },
    {
      "date": "Oct 2020",
      "text": "👩🏻‍🏫 Paper presentation & demo (MyButler) at CSCW 2020"

    },
    {
      "date": "Aug 2020",
      "text": "👩🏻‍🏫 Presentation at 2020 HCI@KAIST " +
          "Summer Workshop",
    },
    // {
    //   "date": "Mar 2020",
    //   "text": "🗞 Paper accepted to ACM CSCW 2020"
    // },
    {
      "date": "Feb 2020",
      "text": "👩🏻‍🎓 Officially a Master in Computer Science"
    },
    {
      "date": "Sep 2019",
      "text": "🏆 Best TA Award of KAIST CS for _CS341: Intro to Networking_"
    },
    {
      "date": "Aug 2019",
      "text": "✈️ Google WTM Scholars Retreat (Aug 27-Sep 1) in Sydney, Australia",
    },
    {
      "date": "Aug 2019",
      "text": "👩🏻‍🏫 Presentation at 2019 HCI@KAIST Summer Workshop",
    },
    {
      "date": "Jul 2019",
      "text": "🏆 Google Women Techmakers (WTM) Scholar 2019"
    }
    // {
    //   "date": "Jul 2019",
    //   "text": "🗞 Paper accepted to ACM IMWUT (UbiComp) 2019"
    // }
  ],
};

export { newsData };